/** @jsx jsx */
import { jsx } from '@emotion/react';
import React from 'react';
import { Select } from '@blueprintjs/select';
import { Button, Classes, MenuItem } from '@blueprintjs/core';
import { PropTypes } from 'prop-types';
import { textItemFilterer, textItemRenderer, textItemStyles } from './utils';

/**
 * Standardized dropdown for simple text items
 *
 * @param activeItem
 * @param onSelectionChanged
 * @param options
 * @param optionToString
 * @param emptyText
 * @param customRender
 * @param rest
 * @returns {*}
 * @constructor
 */
export const ObjectDropdown = ({
	activeItem,
	onSelectionChanged,
	options = [],
	optionToString,
	emptyText = 'Select',
	customRender,
	disabled = false,
	...rest
}) => (
	<Select
		items={options}
		itemPredicate={textItemFilterer(optionToString)}
		itemRenderer={textItemRenderer(optionToString)}
		noResults={<MenuItem disabled={true} text="No items." />}
		onItemSelect={onSelectionChanged}
		activeItem={activeItem}
		popoverProps={{ minimal: true }}
		{...rest}
		disabled={disabled}
	>
		{customRender || (
			<Button
				rightIcon="caret-down"
				minimal
				css={textItemStyles}
				text={optionToString(activeItem) || emptyText}
				disabled={disabled}
				cy-test={rest['cy-test']}
			/>
		)}
	</Select>
);

ObjectDropdown.propTypes = {
	activeItem: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number]),
	customRender: PropTypes.any,
	emptyText: PropTypes.string,
	onSelectionChanged: PropTypes.func,
	optionToString: PropTypes.func.isRequired,
	options: PropTypes.array.isRequired,
	disabled: PropTypes.bool,
};
 